module.exports = __webpack_public_path__ + "img/main_button_search_down.e43aafef.png";